export class AnalyticEvent {
    public static event = {
        appLoaded: 'Web App Loaded',
        emergencyHelp: 'Emergency Help',
        hotlineCalled: 'Hotline Called',
        called911: '911 Called',
        protocallNumberCalled: 'Protocall Number Called',
        moodCheckOpen: 'MoodCheck Open',
        moodCheckCancel: 'MoodCheck Cancel',
        moodCheckComplete: 'MoodCheck Complete',
        moodCheckMoodTab: 'Moodcheck Enter Mood Tab',
        moodCheckSelectEmotion: 'MoodCheck Select Emotion ',
        moodCheckSelectActivity: 'MoodCheck Select Activity',
        moodCheckAddCustomOption: 'MoodCheck Add Custom Option',
        moodCheckSelectNote: 'MoodCheck Selet Note',
        moodCheckEnterNoteTab: 'MoodCheck Enter Note Tab',
        moodCheckSelectPeople: 'MoodCheck Select People',
        moodCheckEnterPeopleTab: 'MoodCheck Enter People Tab',
        moodCheckSelectPlace: 'MoodCheck Select Place',
        moodCheckEnterPlaceTab: 'MoodCheck Enter Place Tab',
        register: 'Register',
        dashboardFilterMood: 'Dashboard Filter Moods',
        dashboardFilterHeatMap: 'Dashboard Filter Heatmap',
        passwordReset: 'Password Reset',
        login: 'Login',
        settings: 'Settings',
        notification: 'Notifcation',
        syncWithCounselor: 'Sync With Counselor',
        myInfo: 'My Information',
        logout: 'Logout',
        courseLoaded: 'Series Loaded',
        courseDetailsLoaded: 'Series Details Loaded',
        counselorPair: 'Counselors Pair',
        counselorUnpair: 'Counselors UnPair',
        accessCodeComplete: 'Access Code Completed',
        accessCodeCreated: 'Access Code Created',
        accessCodeEmailed: 'Acess Code Emailed',
        preferenceChange: 'Preference Change',
        activitySchedulerListingLoaded: 'Activity Scheduler Listing Loaded',
        activitySchedulerDetailsLoaded: 'Activity Scheduler Details Loaded',
        activitySchedulerDetailsCreated: 'Activity Scheduler Details Created',
        activitySchedulerDetailsUpdated: 'Activity Scheduler Details Updated',
        activitySchedulerDetailsDeleted: 'Activity Scheduler Details Deleted',
        activityDeleted: 'Activity Deleted',
        markAsCompleteActivity: 'Mark as Complete Activity',
        calendarLoad: 'Calendar Load',
        calendarDayClick: 'Calendar Day Click',
        favourites: 'Favourite Listing',
        pushNotificationUpdates: 'Push Notification Updated',
        pushNotificationSchduled: 'Push Notification Scheduled',
        systemPermissionAdded: 'System Permission Added',
        systemPermissionUpdated: 'System Permission Updated',
        zenroomLoaded: 'Zen Room Loaded',
        funAchievementDetailsUpdated: 'Fun Achievement Details Updated',
        funAchievementDetailsCreated: 'Fun Achievement Details Created',
        funAchievementListing: 'Fun Achievement Listing',
        practiceLoaded: 'Practice Loaded',
        thoughtDairyDetailsLoaded: 'Thought Diary Details Loaded',
        thoughtDairyDetailsUpdate: 'Thought Diary Details Update',
        thoughtDairyDetailsCreate: 'Thought Diary Details Create',
        thoughtDairyDetailsSaveLater: 'Thought Diary Details Save Later',
        thoughtDairyListing: 'Thought Diary Listing',
        zenroomPlayBackgroundTrack: 'Zenroom Play Background Track',
        zenroomPlayVoiceTrack: 'Zenroom Play Voice Track',
        zenroomPlay: 'Zenroom Play',
        share: 'Share',
        listingLoaded: 'Listing Loaded',
        cdQuizLoaded: 'CD Quiz Loaded',
        cdQuizCreated: 'CD Quiz Created',
        pushNotificationDelete: 'Notification Delete',
        pushNotification: 'Push Notification',
        assessmentListingLoaded: 'Assessment Listing Loaded',
        assessmentCreated: 'Assessment Created',
        assessmentUpdated: 'Assessment Updated',
        assessmentDeleted: 'Assessment Deleted',
        assessmentLoaded: 'Assessment Loaded',
        challengeListingLoaded: 'Challenge Listing Loaded',
        chartLoaded: 'Chart Loaded',
        userDetailsLoaded: 'User Details Loaded',
        addictionListionLoaded: 'Addiction Listing Loaded',
        organizationLoaded: 'Organization List Loaded',
        organizationUpdated: 'Organization Updated',
        organizationCreated: 'Organization Created',
        organizationDetailsLoaded: 'Organization Details Loaded',
        loggedIn: ' LoggedIn Successfully',
        resourceImported: 'Resource Imported',
        resourceExported: 'Resource Exported',
        resourcePageLoaded: 'Resource Page Loaded',
        resourceCloned: 'Resource Cloned',
        userDetailsUpdated: 'User Details Updated',
        userInvitationSent: 'Invitation Sent',
        dashboardLoaded: 'Dashboard Loaded',
        languageSwitched: 'Language Switched to ',
        organizationSwitched: 'Organization Switched',
        updated: 'Updated',
        emailUpdated: 'Email updated',
        settingsUpdated: 'Settings Updated',
        subscriptionCancelled: 'Subscription Cancelled',
        organizationRemoved: 'Organization Removed',
        activityListLoaded: 'Activity List loaded',
        activityListed: 'Activity Listed',
        updateOrganization: 'Organization Updated',
        calendarEvents: 'Calendar Loaded',
        activityScheduled: 'ActivityScheduled Loaded',
        activityUpdated: 'Activity Updated ',
        appInstalled: 'App installed',
        dashboard: 'Dashboard',
        dashboardMcSummaryView: 'Dashboard Moodcheck Summary View',
        dashboardMcBreakdownView: 'Dashboard Moodcheck Breakdown View',
        dashboardMcEmotionView: 'Dashboard Moodcheck Emotion Details View',
        userInfoUpdated: 'User Info Updated',
        userEmailUpdated: 'User Email Updated',
        userAssociationPage: 'User Association Page',
        userAssociationChanged: 'User Association Changed',
        actionPlanListingView: 'Action Plan Listing View',
        actionPlanCreateView: 'Action Plan Create View',
        actionPlanEditView: 'Action Plan Edit View',
        actionPlanCreated: 'Action Plan Created',
        actionPlanUpdated: 'Action Plan Updated',
        actionPlanDelete: 'Action Plan Deleted',
        actionPlanPreview: 'Action Plan Preview',
        actionPlanDownloaded: 'Action Plan Downloaded',
        assessmentListingView: 'Assessment listing view',
        dasAssessmentDetailsView: 'DASS Assessment details view',
        mentalwellbeingAssessmentDetailsView:
            'Mental Wellbeing Assessment details view',
        resilienceAssessmentDetailsView: 'Resilience Assessment details view',
        anxietyAssessmentDetailsView: 'Anxiety Assessment details view',
        depressionAssessmentDetailsView: 'Depression Assessment details view',
        alcoholuseAssessmentDetailsView: 'Alcohol Use Assessment details view',
        dasAssessmentResultView: 'DASS Assessment result view',
        mentalwellbeingAssessmentResultView:
            'Mental Wellbeing Assessment result view',
        resilienceAssessmentResultView: 'Resilience Assessment result view',
        anxietyAssessmentResultView: 'Anxiety Assessment result view',
        depressionAssessmentResultView: 'Depression Assessment result view',
        alcoholuseAssessmentResultView: 'Alcohol Use Assessment result view',
        dasAssessmentSubmitted: 'DASS Assessment submitted',
        mentalwellbeingAssessmentSubmitted:
            'Mental Wellbeing Assessment submitted',
        resilienceAssessmentSubmitted: 'Resilience Assessment submitted',
        anxietyAssessmentSubmitted: 'Anxiety Assessment submitted',
        depressionAssessmentSubmitted: 'Depression Assessment submitted',
        alcoholuseAssessmentSubmitted: 'Alcohol Use Assessment submitted',
        dasAssessmentDeleted: 'DASS Assessment deleted',
        mentalwellbeingAssessmentDeleted: 'Mental Wellbeing Assessment deleted',
        resilienceAssessmentDeleted: 'Resilience Assessment deleted',
        anxietyAssessmentDeleted: 'Anxiety Assessment deleted',
        depressionAssessmentDeleted: 'Depression Assessment deleted',
        alcoholuseAssessmentDeleted: 'Alcohol Use Assessment deleted',
        assessmentQuestionsFetchError: 'Assessment question fetch error',
        assessmentDeleteError: 'Assessment delete error',
        assessmentSubmitError: 'Assessment submit error',
        assessmentListingError: 'Assessment list error',
        assessmentGraphError: 'Assessment graph error',
        pdfDownloaded: 'Pdf Downloaded',
        crafftAssessmentSubmitted: "CRAFFT 2.1 Assessment submitted",
        crafftAssessmentResultView: "CRAFFT 2.1 Assessment result view",
        crafftAssessmentDeleted: "CRAFFT 2.1 Assessment deleted",
        crafftAssessmentDetailsView: "CRAFFT 2.1 Assessment details view",
    };
    public static commonEvents = {
        buttonClicked: 'Button Clicked',
        videoPlayed: 'Video Played',
        videoPaused: 'Video Paused',
        videoEnded: 'Video Ended',
        video: 'Video',
        notificationAction: 'Notification Action',
        notificationURL: 'Notification URL',
        notificationClicked: 'Notification Clicked',
        pushNotification: 'Push Notification',
        loginWithReferralLink: 'Login with Referral Link',
        confirmAccountLink: 'Confirm Account Link',
        accountConfirmed: 'Account Confrmed',
        passwordChangeLink: 'Password Change Link',
        category: 'Category',
        voicePlayed: 'Voice Played',
        voicePaused: 'Voice Paused',
        voiceEnded: 'Voice Ended',
    };
    public static internalPagesEvents = {
        seriesDashboardPage: 'Series dashboard page',
        voiceSeriesHomePage: 'Voice series home page',
        storiesListingPage: 'Stories listing page',
        videoSeriesListingPage: 'Video series listing page',
        burningQuestionsListingPage: 'Burning Questions listing page',
        voicePlayerPage: 'Voice player page',
        seriesCategoryDetailsPage: 'Series category details page',
        categoryListLoaded: 'Category list loaded',
        categoryListFetchError: 'Category list fetch error',
        videoListLoaded: 'Video list loaded',
        videoListFetchError: 'Video list fetch error',
        videoListDefaultLoaded: 'Video default list loaded',
        videoListDefaultFetchError: 'Video default list fetch error',
        storiesListLoaded: 'Stories list loaded',
        storiesListFetchError: 'Stories list fetch error',
        burningQuestionsListLoaded: 'Burning Questions list loaded',
        burningQuestionsListFetchError: 'Burning Questions list fetch error',
        seriesRatingAdded: 'Series rating submitted',
        seriesRatingSubmitError: 'Series rating submit error',
        dailyContentLoaded: 'Daily content loaded',
        dailyContentFetchError: 'Daily content fetch error',
        pastDailyContentLoaded: 'Past daily content loaded',
        pastDailyContentFetchError: 'Past daily content fetch error',
        userFeedbackSurvey: 'User Feedback Survey',
        npsSurvey: 'User Experience Survey',
        demographicSurvey: 'Demographic Survey',
        surveySubmitted: 'Survey submitted',
        surveySubmitError: 'Survey submit error',
        surveyAnswerSubmitted: 'Survey answer submitted',
        surveyAnswerSubmitError: 'Survey answer submit error',
        surveyClosed: 'Survey Closed',
        userSurveyPopup: 'User survey popup',
        customOrgSeriesPage: "Custom organization series page",
    customOrgVideoSeriesFetchError:
      "Custom organization video series fetch error",
    customOrgStorySeriesFetchError:
      "Custom organization story series fetch error",
    customOrgBurningQuestionSeriesFetchError:
      "Custom organization burning question series fetch error",
    customOrgReadsSeriesFetchError:
      "Custom organization reads series fetch error",
    customOrgReadItemClicked: "Custom organization read item clicked",
    };
}
